import { SUB_TYPES } from '@/utils/templates/databaseTemplate/database.constants';
import i18n from '@/plugins/i18n';
import * as constants from '@/utils/templates/databaseTemplate/database.constants';

//database Types
const DatabaseTypes = Object.freeze({
  my: 'MY',
  cb: 'CB',
  es: 'ES',
  or: 'OR',
  ca: 'CA',
  pg: 'PG',
  ms: 'MS',
  mg: 'MG',
});

const queryTypes = Object.freeze({
  QUERY_DATABASE_DETAILS: 'queryDatabaseDetails',
  QUERY_SESSION_DETAILS: 'querySessionDetails',
  QUERY_LABLED_VALUES: 'queryLabledValues',
  QUERY_EVENT_DETAILS: 'queryEventDetails',
  QUERY_PERFORMANCE: 'queryPerformaceDetails',
});

const metricTypes = Object.freeze({
  METER_POSTGRESS_DISK_SIZE_USED: 'meter_postgres_disk_size_used',
  METER_POSTGRESS_DISK_SIZE_TOTAL: 'meter_postgres_disk_size_total',
  METER_POSTGRESS_DISK_SIZE_AVAILABLE: 'meter_postgres_disk_size_available',
  METER_POSTGRESS_MEMORY_UASGE: 'meter_postgres_memory_usage',
  METER_POSTGRESS_CPU_USUAGE: 'meter_postgres_cpu_usage',
  METER_POSTGRESS_SESSION_DETAILS: 'meter_postgres_session_details',
  DBM_QUERIES: 'dbm_queries',
  METER_POSTGRES_CPU_USAGE: 'meter_postgres_cpu_usage',
  METER_POSTGRES_MEMORY_USAGE: 'meter_postgres_memory_usage',
});
const metricTypes_mysql = Object.freeze({
  METER_MYSQL_DISK_SIZE_USED: 'meter_disk_size_used',
  METER_MYSQL_DISK_SIZE_TOTAL: 'meter_disk_size_total',
  METER_MYSQL_DISK_SIZE_AVAILABLE: 'meter_disk_size_available',
  METER_MYSQL_SESSION_DETAILS: 'meter_session_details',
  METER_MYSQL_CPU_USAGE: 'meter_cpu_usage',
  METER_MYSQL_MEMORY_UASGE: 'meter_memory_usage',
});
const metricTypes_cassandra = Object.freeze({
  METER_CASSANDRA_DISK_SIZE_USED: 'meter_cassandra_disk_size_used',
  METER_CASSANDRA_DISK_SIZE_TOTAL: 'meter_cassandra_disk_size_total',
  METER_CASSANDRA_DISK_SIZE_AVAILABLE: 'meter_cassandra_disk_size_available',
  METER_CASSANDRA_SESSION_DETAILS: 'meter_cassandra_session_details',
  METER_CASSANDRA_CPU_USAGE: 'meter_cassandra_cpu_usage',
  METER_CASSANDRA_MEMORY_UASGE: 'meter_cassandra_memory_usage',
  EVENT_QUERIES: 'event_queries',
});

const metricOrTypes = Object.freeze({
  METER_ORACLE_DISK_SIZE_USED: 'meter_oracle_disk_size_used',
  METER_ORACLE_DISK_SIZE_TOTAL: 'meter_oracle_disk_size_total',
  METER_ORACLE_DISK_SIZE_AVAILABLE: 'meter_oracle_disk_size_available',
  METER_ORACLE_MEMORY_UASGE: 'meter_oracle_memory_usage',
  METER_ORACLE_CPU_USAGE: 'meter_oracle_db_cpu_usage_per_second',
  METER_ORACLE_SESSION_DETAILS: 'meter_oracle_session_details',
});

const metricMSTypes = Object.freeze({
  METER_SESSION_DETAILS: 'meter_session_details',
});

export const metricCouchbaseTypes = Object.freeze({
  METER_COUCHBASE_DISK_SIZE_USED: 'meter_couchbase_clusters_disk_size_used',
  METER_COUCHBASE_DISK_SIZE_TOTAL: 'meter_couchbase_clusters_disk_size_total',
  METER_COUCHBASE_DISK_SIZE_AVAILABLE:
    'meter_couchbase_clusters_disk_size_available',
  METER_COUCHBASE_NODE_DISK_SIZE_USED:
    'meter_couchbase_nodes_node_disk_size_used',
  METER_COUCHBASE_NODE_DISK_SIZE_TOTAL:
    'meter_couchbase_nodes_node_disk_size_total',
  METER_COUCHBASE_NODE_DISK_SIZE_AVAILABLE:
    'meter_couchbase_nodes_node_disk_size_available',
});

export const metricMongoDBTypes = Object.freeze({
  METER_MONGO_DISK_SIZE_USED: 'meter_mongodb_disk_size_used',
  METER_MONGO_DISK_SIZE_TOTAL: 'meter_mongodb_disk_size_total',
  METER_MONGO_CPU_USAGE: 'meter_mongodb_cpu_usage',
  METER_MONGO_MEMORY_UASGE: 'meter_mongodb_memory_usage',
});

export const databaseMutation = {
  SET_AVG_CPU: 'SET_AVG_CPU',
  SET_AVG_MEMORY: 'SET_AVG_MEMORY',
};

export const databaseGetters = {
  GET_AVG_CPU: 'GET_AVG_CPU',
  GET_AVG_MEMORY: 'GET_AVG_MEMORY',
};
export const databaseActions = {
  GET_ALL_QUERY_RECORDS: 'GET_ALL_QUERY_RECORDS',
  GET_SESSION_DETAILS: 'GET_SESSION_DETAILS',
  GET_DB_DISK_DATA: 'GET_DB_DISK_DATA',
  GET_ALL_EVENT_RECORDS: 'GET_ALL_EVENT_RECORDS',
  GET_AVG_DATA: 'GET_AVG_DATA',
  GET_QUERY_PERFORMANCE_DATA: 'GET_QUERY_PERFORMANCE_DATA',
};
// TODO: i18n needs to be handled in this file
export const cardNames = {
  TYPE_OF_OS: 'Type of OS',
  ARCHITECTURE: 'Architecture',
  Host_Name: 'Host name',
  Availability: 'Availability',
};

export const clusterCardsName = {
  CLUSTER_NAME: 'Cluster name',
  KEYSPACE_NAME: 'Keyspace name',
  DATA_CENTER: 'Data center',
  CQL_VERSION: 'Cql version',
  RACK: 'Rack',
  UPTIME: 'Uptime',
};

export const cardValues = {
  OS_TYPE: 'os_type',
  OS_ARCH: 'os_arch',
  OS_NAME: 'os_name',
  AVAILABILITY: 'availability',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
};

export const cassandraCardValues = {
  CS_OS_TYPE: 'cas_os_type',
  CS_OS_ARCH: 'cas_os_arch',
  CS_OS_NAME: 'cas_os_name',
  CS_AVAILABILITY: 'cas_availability',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  CS_KEYSPACE_NAME: 'cas_keyspace_name',
  CS_CLUSTER_NAME: 'cas_cluster_name',
  CS_CQL_VERSION: 'cas_cql_version',
  CS_DATA_CENTER: 'cas_data_center',
  CS_RACK: 'cas_rack',
};
export const mysqlClusterCardNames = {
  LOAD_AVG: 'Load average',
  HOST: 'Host',
  PORT: 'Port',
  ROLE: 'Role',
  STATUS: 'Status',
};
export const mysqlClusterCardValues = {
  LOAD_AVG: 'load_avg',
  HOST: 'member_host',
  PORT: 'member_port',
  ROLE: 'member_role',
  STATUS: 'member_state',
};

export const mssqlClusterCardNames = {
  LOAD_AVG: 'Load average',
  HOST: 'Host',
  PORT: 'Port',
  ROLE: 'Role',
  STATUS: 'Status',
};

export const mssqlClusterCardValues = {
  LOAD_AVG: 'mssql_load',
  HOST: 'mssql_host_name',
  PORT: 'instance_port',
  ROLE: 'mssql_role_name',
  STATUS: 'availability',
};

export const couchbaseCardValues = {
  CB_NAME: 'cb_cluster_name',
  CB_VERSION: 'cb_version',
  CB_STATUS: 'cb_availability',
  CB_NO_OF_NODES: 'cb_total_nodes',
  CB_NO_OF_BUCKETS: 'cb_total_buckets',
  CB_NODE_NAME: 'cb_node_name',
  CB_NODE_VERSION: 'cb_node_version',
  CB_NODE_STATUS: 'cb_node_status',
  CB_NODE_OS: 'cb_node_os',
  CB_NODE_UPTIME: 'cb_node_uptime',
};

export const couchbaseCardNames = {
  CLUSTER_NAME: 'Cluster name',
  COUCHBASE_VERSION: 'Couchbase version',
  STATUS: 'Status',
  NO_OF_NODES: 'Number of nodes',
  NO_OF_BUCKETS: 'Number of buckets',
  NODE_NAME: 'Node name',
  NODE_VERSION: 'Node version',
  NODE_STATUS: 'Node status',
  NODE_OS: 'Node OS',
  NODE_UPTIME: 'Node uptime',
};

export const graphLabels = () =>
  Object.freeze({
    [SUB_TYPES.MONGO_RESOURCE]: [
      {
        key: 'saturation',
        label: i18n.global.t('dbm.saturation'),
      },
      {
        key: 'usage',
        label: i18n.global.t('dbm.usage'),
      },
    ],
  });

const instanceMapping = Object.freeze({
  MY: constants.NODE,
  OR: constants.SUB_TYPES.ORA_INSTANCE,
  PG: constants.SUB_TYPES.POS_INSTANCE,
  MS: 'ms-instance',
  MG: constants.SUB_TYPES.MONGO_INSTANCE,
  CA: constants.SUB_TYPES.CAS_INSTANCE,
});

const timeStamp = 'timestamp';
const queryTimePattern = 'DD.MM.YY [at] hh:mm A';
const pdfTableSize = 50;

const sourceElapsed = 'sourceElapsed';
const TIMESTAMP = 'timeStamp';

const queryTableSortFieldMapping = {
  timestamp: 'time_bucket',
  count: 'unique_query_count',
  value: 'query_order',
};

const sessionTableSortFieldMapping = {
  timeStamp: 'TIMESTAMP',
  deadlock: 'DEADLOCK',
  label: 'NAME',
  value: 'VALUE',
};

const eventDetailsTableSortFieldMapping = {
  activity: 'activity',
  source: 'source',
  sourceElapsed: 'sourceElapsed',
};

export {
  DatabaseTypes,
  queryTypes,
  metricTypes,
  metricOrTypes,
  metricTypes_cassandra,
  metricTypes_mysql,
  timeStamp,
  queryTimePattern,
  pdfTableSize,
  metricMSTypes,
  instanceMapping,
  queryTableSortFieldMapping,
  sessionTableSortFieldMapping,
  eventDetailsTableSortFieldMapping,
  sourceElapsed,
  TIMESTAMP,
};
